import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { ProgressBar } from '../../../progress-bar/progress-bar';

const SkyViewProgressBar = () => {
  const { t } = useTranslation('components');
  const loadingProgressMessage = useSubscribe(SubscriptionTopic.SkyviewLoadingProgress);
  const theme = useTheme();

  return (
    <ProgressBar
      backgroundColor={theme.color.brand.lightest}
      height={'2.5em'}
      max={1}
      min={0}
      text={t('skyviewLoader.loadingText', { ns: 'components' })}
      value={loadingProgressMessage?.progress ?? 0}
    />
  );
};

export { SkyViewProgressBar };
